<template>
  <va-edit-layout>
    <stat-question_options-form
      :id="id"
      :title="title"
      :item="item"
    ></stat-question_options-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
